import React from 'react';
import { useColors } from '@osmosis/tailwind-ui/helpers/useColors';

type Props = {
  [key: string]: string | number;
};

/**
 * Playlist Header Icon.
 */
const PlaylistIcon = (props: Props) => {
  const { fill = 'light', color, ...rest } = props;
  const colors = useColors();
  return (
    <svg
      viewBox="0 0 315 308"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      data-icon="playlist"
      fill={(color as string) || colors[fill] || 'currentColor'}
      className="h-5 w-5"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2,
      }}
      data-prevent-nprogress={true}
      {...rest}
    >
      <path
        data-prevent-nprogress={true}
        d="M201.425 178.74c2.59.1 3.02.3 4.16.6 1.15.3 1.61.4 3.93 1.6l94.85 50.1c7.64 4.3 11.71 13.7 9.32 22-1.54 5.3-5.61 9.8-10.65 12.1l-94.85 41c-11.33 4.6-25.81-3.4-26.39-16.5-.01-.3-.01-.6-.02-.9v-91.1c.02-.8.01-1 .07-1.7.78-8.7 8.23-16.3 17.04-17.1 1.64-.2 2.02-.1 2.54-.1Zm-81.29 60.1h-96.51c-12.22-.2-23.12-10.5-23.61-22.7-.5-12.3 9.98-24 22.66-24.5H121.085c9.65.6 18.47 7.1 21.47 16.1 3.51 10.5-1.53 23.2-11.44 28.4-3.37 1.8-7.16 2.7-10.98 2.7Zm141.13-95H23.625c-1.32 0-1.65 0-2.96-.2-12.18-1.5-22.08-13.8-20.49-26.4 1.42-11.2 11.67-20.301 23.45-20.601h239.13c13 1.2 23.6 13.6 21.96 26.6-1.3 10.3-10.12 19.1-20.48 20.4-1.31.2-1.65.2-2.97.2Zm.71-96.501H23.625c-10.58-.3-20.33-7.8-22.89-17.8-3.3-12.8 6.29-27.6 19.93-29.3 1.31-.1 1.64-.1 2.96-.2h238.35c.49 0 .98.1 1.48.1 10.03.9 18.95 8.1 21.4 17.7 3.31 12.8-6.28 27.6-19.92 29.3-1.31.2-1.65.2-2.96.2Z"
      />
    </svg>
  );
};

export default PlaylistIcon;
